export function initModal() {
  const customModalEl = document.querySelector('.custom-modal');
  if (customModalEl) {
    const customModalInner = customModalEl.querySelector('.custom-modal-inner');
    const customModalContent = customModalInner.querySelector('.custom-modal-content');
    const closeModalElm = customModalInner.querySelector('.close-modal');
    const closeModal = () => {
      // region allow page scroll
      document.documentElement.classList.remove('modal-opened')
      // endregion allow page scroll
      customModalEl.classList.remove('modal-active');
      setTimeout(() => {
        customModalContent.innerHTML = '';
      }, 300)
    }

    const keyHandler = (e) => {
      if (e.key === 'Escape') {
        -
          closeModal();
        // clearModal();
      }
    }
    window.addEventListener('keydown', keyHandler)

    customModalEl?.addEventListener('click', closeModal);
    customModalInner?.addEventListener('click', e => e.stopPropagation());
    closeModalElm?.addEventListener('click', closeModal);
  }
}
